import styles from "./PreviewBooster.module.css";
import showCardsStyles from "../../Cards/ShowCards/ShowCards.module.css";
import {
  BoosterCards,
  boosterData,
  getBoosterById,
  getCardsForBooster,
} from "../../../services/BoosterServices";
import React, { useEffect, useState } from "react";
import Card from "../../Cards/Card";
import { RarityDistribution } from "../Booster";
import { Link, useParams } from "react-router-dom";
import { AddToCartButton } from "../../Buttons/AddToCartButton/AddToCartButton";
import { FaCircleInfo } from "react-icons/fa6";
import globalStyles from "../../../styles/globalStyles.module.css";
import { ReportButton } from "../../Buttons/ReportButton/ReportButton";
import { useTranslation } from "react-i18next";

export const PreviewBooster: React.FC = () => {
  const [cards, setCards] = useState<BoosterCards[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rarityDistribution, setRarityDistribution] =
    useState<RarityDistribution>({
      common: 0,
      silver: 0,
      gold: 0,
    });
  const { boosterId } = useParams<{ boosterId: string }>();
  const [booster, setBooster] = useState<boosterData>();
  const [numberCardsOwned, setNumberCardsOwned] = useState<number>(0);
  // const [maxPurchasable, setMaxPurchasable] = useState<number>(0);
  const { t } = useTranslation();
  const cardMissing =
    rarityDistribution.common +
    rarityDistribution.silver +
    rarityDistribution.gold -
    numberCardsOwned;

  useEffect(() => {
    const fetch = async (boosterId: string) => {
      const fetchedBooster = await getBoosterById(boosterId);

      if (!fetchedBooster) {
        console.log("error fetching booster");
        return;
      }

      setBooster(fetchedBooster);

      const fetchedCards = await getCardsForBooster(boosterId);

      setCards(fetchedCards);

      const newDistribution = { common: 0, silver: 0, gold: 0 };
      var newNumberOfCardsOwned = 0;

      for (const card of fetchedCards) {
        newDistribution[card.rarity] += 1;
        if (card.is_owned) {
          newNumberOfCardsOwned += 1;
        }
      }

      setRarityDistribution(newDistribution);
      setNumberCardsOwned(newNumberOfCardsOwned);

      // const maxQuantity = await getMaxPurchasableQuantity(boosterId);

      // setMaxPurchasable(maxQuantity);
    };

    if (!isLoading) setIsLoading(true);
    try {
      const id = boosterId;
      if (!id) return;
      // if (cards.length > 0) return;
      fetch(id);
    } catch {
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [boosterId]);

  return (
    <div className={styles.container}>
      <div className={globalStyles.pageTitle}>
        {booster?.username} is selling
      </div>
      <div className={styles.header}>
        <div>
          <img
            src={booster?.image_id}
            alt="Booster"
            className={styles.boosterModalImage}
          />
        </div>
        <div className={styles.informations}>
          <Link
            to={`/profile/${booster?.username}`}
            className={styles.profileRedirect}
          >
            <div className={styles.creator}>
              {booster?.profile_picture_url && (
                <img
                  alt="profile_picture"
                  className={styles.profilePictureImage}
                  src={booster?.profile_picture_url}
                />
              )}
              <h4>{booster?.username ?? booster?.username}</h4>
            </div>
          </Link>{" "}
          <div>
            <h4>
              {t("boosters.preview.digitalBooster")} - {booster?.name}
            </h4>

            <p>
              {booster?.created_at &&
                new Date(booster.created_at).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                })}
            </p>
          </div>
          <h1>
            {booster?.is_in_store ? (
              <strong>{booster?.price}€</strong>
            ) : (
              <strong>{t("notForSale")}</strong>
            )}
          </h1>
          {booster?.description && (
            <div>
              {t("description")} : {booster.description}
            </div>
          )}
          {booster?.is_in_store && (
            <>
              <AddToCartButton
                booster={booster!}
                cardsMissing={cardMissing}
                numberOfCards={cards.length}
              />
              <div>
                <FaCircleInfo />
                {t("boosters.preview.infoNumberCards")}
              </div>
              <div>
                <FaCircleInfo />
                {t("boosters.preview.infoNoDuplicate")}
              </div>
              <div>
                <FaCircleInfo /> {t("boosters.preview.infoPrints")}{" "}
              </div>
            </>
          )}
          <ReportButton />
        </div>
      </div>
      <h5>
        {t("boosters.preview.cardsInfo", {
          count:
            rarityDistribution.common +
            rarityDistribution.silver +
            rarityDistribution.gold,
        })}
      </h5>
      <p>
        {t("boosters.preview.missing")}{" "}
        <strong>
          {rarityDistribution.common +
            rarityDistribution.silver +
            rarityDistribution.gold -
            numberCardsOwned}{" "}
        </strong>
        {t("cards.label")}
      </p>
      <div className={showCardsStyles.cardContainer}>
        {cards &&
          cards.map((card, index) => (
            <div className={showCardsStyles.cardWrapper} key={index}>
              <div
                className={`${showCardsStyles.cardWidth} ${styles.cardStyle} ${
                  card.is_owned && styles.owned
                }`}
              >
                <Card cardData={card} />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
